import { QueryParamsForAssignRiders } from '@rideiq/organizers/types';
import { useBulkRiderMutations } from '@rideiq/riders/hooks/useBulkRiderMutations';
import { useToastStore } from '@rideiq/shared/stores/toastStore';

import { useBulkRiderStatusToast } from './useBulkRiderStatusToast';

interface UseBulkReactivateRidersOptions {
  selectedRiderIds: number[];
  isAllFilteredSelected: boolean;
  totalCount: number;
  queryParams: QueryParamsForAssignRiders;
  onSuccess: () => void;
}

export const useBulkReactivateRiders = ({
  selectedRiderIds,
  isAllFilteredSelected,
  totalCount,
  queryParams,
  onSuccess,
}: UseBulkReactivateRidersOptions) => {
  const { addToast } = useToastStore();
  const { reactivateRiders } = useBulkRiderMutations();
  const { showStatusResultsToast } = useBulkRiderStatusToast();

  const riderCount = isAllFilteredSelected ? totalCount : selectedRiderIds.length;
  const riderLabel = riderCount === 1 ? 'Rider' : 'Riders';

  const submit = async () => {
    const response = await reactivateRiders({
      passengerIds: isAllFilteredSelected ? 'all' : selectedRiderIds,
      riderCount,
      queryParams,
    });

    if (response.type === 'error') {
      addToast({
        severity: 'error',
        message:
          response.error.errors.filter((message) => message.trim()).join(' ') ||
          'Failed to reactivate riders. Please try again.',
      });

      return;
    }

    if (isAllFilteredSelected && !response.data.results?.length) {
      addToast({ severity: 'success', message: 'Riders reactivated.' });
      onSuccess();

      return;
    }

    showStatusResultsToast(response.data.results ?? [], 'reactivate');
    onSuccess();
  };

  return { submit, riderCount, riderLabel };
};
